export const THREAD_LIST = 'thread-list';
export const THREAD_VIEW = 'thread-view';
export const KNOWLEDGE_BASE = 'knowledge-base';
export const KNOWLEDGE_BASE_ARTICLE = 'knowledge-base-article';
export const CATEGORY_VIEW = 'category-view';
export const ARTICLE = 'article';
export const CATEGORY = 'category';